/**
 * App base path utilities.
 *
 * LexIDE is a standalone SPA hosted at its own origin, so BASE_URL is
 * always "/". This helper is kept so Clerk URL props (which navigate
 * outside React Router) resolve correctly if a future deployment
 * re-introduces a sub-path prefix.
 */

const basename = import.meta.env.BASE_URL.replace(/\/+$/, "") || "";

/** Resolve a route path into an absolute URL that includes the app basename. */
export function resolveAppUrl(path: string): string {
  return `${basename}${path}`;
}
